/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Account } from './Account';
import {
    AccountFromJSON,
    AccountFromJSONTyped,
    AccountToJSON,
    AccountToJSONTyped,
} from './Account';

/**
 * 
 * @export
 * @interface Follow
 */
export interface Follow {
    /**
     * Unique identifier for the follow relationship
     * @type {string}
     * @memberof Follow
     */
    readonly id: string;
    /**
     * Account that is following
     * @type {Account}
     * @memberof Follow
     */
    readonly follower: Account;
    /**
     * ID of the account that is following
     * @type {string}
     * @memberof Follow
     */
    readonly followerId: string;
    /**
     * Account that is being followed
     * @type {Account}
     * @memberof Follow
     */
    readonly following: Account;
    /**
     * ID of the account that is being followed
     * @type {string}
     * @memberof Follow
     */
    readonly followingId: string;
    /**
     * Timestamp when the follow relationship was created
     * @type {Date}
     * @memberof Follow
     */
    readonly createdAt: Date;
    /**
     * Timestamp when the follow relationship was last updated
     * @type {Date}
     * @memberof Follow
     */
    readonly updatedAt: Date;
}

/**
 * Check if a given object implements the Follow interface.
 */
export function instanceOfFollow(value: object): value is Follow {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('follower' in value) || value['follower'] === undefined) return false;
    if (!('followerId' in value) || value['followerId'] === undefined) return false;
    if (!('following' in value) || value['following'] === undefined) return false;
    if (!('followingId' in value) || value['followingId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function FollowFromJSON(json: any): Follow {
    return FollowFromJSONTyped(json, false);
}

export function FollowFromJSONTyped(json: any, ignoreDiscriminator: boolean): Follow {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'follower': AccountFromJSON(json['follower']),
        'followerId': json['followerId'],
        'following': AccountFromJSON(json['following']),
        'followingId': json['followingId'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

  export function FollowToJSON(json: any): Follow {
      return FollowToJSONTyped(json, false);
  }

  export function FollowToJSONTyped(value?: Omit<Follow, 'id'|'follower'|'followerId'|'following'|'followingId'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
    };
}

